import React from 'react';
import { useSelector } from 'react-redux';
import {
    HeaderHeights, AmpHeaderHeights, PostSidebar,
} from 'mm-ui-components';
import { getSecondaryHeader } from '../../store/navigations/ampNavigation/secondaryHeader/secondaryHeader.selectors';

interface PostSidebarProps {
  adId1: string | null;
  adId2: string | null;
  adOnSuccess1: (() => void)| null;
  adOnSuccess2: (() => void)| null;
}

export const AmpHeaderPostSidebarConnected: React.FunctionComponent<PostSidebarProps> = props => {
  const isSecondaryHeaderEnabled = !!useSelector(getSecondaryHeader);
  return (
    <AmpHeaderHeights doesSecondaryHeaderExist={isSecondaryHeaderEnabled}>
      <PostSidebar {...props} />
    </AmpHeaderHeights>
);
};

export const HeaderPostSidebarConnected: React.FunctionComponent<PostSidebarProps> = props => {
  const doesSubHeaderExist = !!useSelector(getSecondaryHeader);
  return (
    <HeaderHeights doesSubHeaderExist={doesSubHeaderExist}>
      <PostSidebar {...props} />
    </HeaderHeights>
);
};
